import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AppMain = _resolveComponent("AppMain")!
  const _component_MerchantRefundDialog = _resolveComponent("MerchantRefundDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.classObj, "app-wrapper"])
  }, [
    (_ctx.classObj.mobile && _ctx.sidebar.opened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "drawer-bg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickOutside && _ctx.handleClickOutside(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, { class: "sidebar-container" }),
    _createVNode(_component_Header),
    _createVNode(_component_AppMain),
    (_ctx.UserType[_ctx.userType] === '合作商户')
      ? (_openBlock(), _createBlock(_component_MerchantRefundDialog, { key: 1 }))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_loading, _ctx.loading]
  ])
}